export default "__VITE_ASSET__e64bad4f__"